/* eslint-disable */
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"
import './index.css';
import App from '@/App';

import '@/localization/i18n';


console.log('Release version:', (import.meta as any).env?.VITE_APP_VERSION || 'dev');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);
